import { Component } from '@/types'

const component: Component = ref => {
  if (!ref.multiPreorderNoticeModal) return

  ref.multiPreorderNoticeModal.forEach((modal: HTMLElement) => {
    const closeButtons = modal.querySelectorAll(
      '[data-ref="multi-preorder-notice-close"]'
    )
    const bg = modal.querySelector('.bg')

    const close = () => {
      modal.style.display = 'none'
    }

    closeButtons.forEach(button => {
      button?.addEventListener('click', close)
    })

    bg?.addEventListener('click', close)

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && modal.style.display !== 'none') {
        close()
      }
    })
  })
}

export function showMultiPreorderNoticeModal() {
  const modal = document.querySelector(
    '[data-ref="multi-preorder-notice-modal"]'
  ) as HTMLElement | null
  if (modal) {
    modal.style.display = 'block'
  }
}

export default component
